<template>
  <v-overlay opacity="0.88" color="graylight" :value="enabled">
    <v-progress-circular
      color="primary"
      indeterminate
      size="48"
    ></v-progress-circular>
  </v-overlay>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
